import type { SVGProps } from 'react';
const SvgIconDeleteTrash = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={27} height={26} {...props}>
    <path
      fill="#1A202C"
      d="M11.726 5.688h3.294c.095 0 .183.045.236.126l.668.998h-5.098l.668-.998a.29.29 0 0 1 .236-.127zm6.226 1.125-1.29-1.938A1.98 1.98 0 0 0 15.024 4h-3.298c-.657 0-1.272.33-1.638.875l-1.29 1.938H6.344a.84.84 0 0 0-.844.843c0 .468.376.844.844.844h.408l.843 11.415A2.25 2.25 0 0 0 9.838 22h7.074c1.177 0 2.155-.91 2.243-2.085L19.998 8.5h.408a.84.84 0 0 0 .844-.844.84.84 0 0 0-.844-.843zm.355 1.687-.836 11.292a.56.56 0 0 1-.563.52h-7.07a.566.566 0 0 1-.562-.52L8.443 8.5z"
    />
  </svg>
);
export default SvgIconDeleteTrash;
